<template>
  <div
    class="gallery-card"
    :class="{
      loading: item.loading,
      'is-empty': !item.url && !item.loading,
      result: !!item.url && !item.loading,
      'is-active-edit': workbench.promo.activeEditIdx === index,
    }"
    :style="cardStyle"
    @click="workbench.promo.activeEditIdx = index"
  >
    <template v-if="item.loading">
      <div class="pulse-bg"></div>
      <div class="card-center">
        <div class="ring">
          <svg class="ring-svg" viewBox="0 0 100 100">
            <circle class="ring-track" cx="50" cy="50" r="40"></circle>
            <circle
              class="ring-stroke"
              cx="50"
              cy="50"
              r="40"
              :style="{
                strokeDashoffset: 251.2 * (1 - (item.progress ?? 0) / 100),
              }"
            ></circle>
          </svg>
          <div class="ring-text">{{ Math.round(item.progress ?? 0) }}%</div>
        </div>
        <p class="load-text">生成中...</p>
      </div>
    </template>

    <template v-else-if="item.url">
      <img :src="item.url" class="card-img" alt="result" @error="onImgError" />

      <button
        class="select-btn"
        :class="{ active: workbench.videoGen.selectedIdxs.includes(index) }"
        @click.stop="workbench.selectPromoForVideo(index)"
      >
        <span class="checkmark">✓</span>
      </button>

      <div class="card-actions">
        <button
          class="action-btn glass"
          title="预览"
          @click.stop="workbench.openLightbox(item.url)"
        >
          <svg
            class="icon-sm"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"
            />
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z"
            />
          </svg>
        </button>
        <button class="action-btn glass" title="重绘" @click.stop="regenerate">
          <svg
            class="icon-sm"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15"
            />
          </svg>
        </button>
        <button
          class="action-btn blue"
          title="下载"
          @click.stop="workbench.downloadImage(item.url)"
        >
          <svg
            class="icon-sm"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M4 16v1a3 3 0 003 3h10a3 3 0 003-3v-1m-4-4l-4 4m0 0l-4-4m4 4V4"
            />
          </svg>
        </button>
      </div>
    </template>

    <template v-else>
      <div class="empty-card">
        <div class="edit-prompt-area">
          <input
            v-model="item.label"
            class="label-input"
            placeholder="输入标签词..."
          />
          <textarea
            v-model="item.customPrompt"
            class="mini-prompt-input"
            placeholder="手动输入或通过 AI 规划..."
          ></textarea>
        </div>
      </div>
    </template>
  </div>
</template>

<script setup>
/* eslint-disable no-undef */
import { computed } from "vue";
import { useWorkbenchStore } from "@/stores/useWorkbenchStore";

const props = defineProps({
  index: {
    type: Number,
    required: true,
  },
});

const workbench = useWorkbenchStore();
const item = computed(() => workbench.promo.items[props.index] || {});

// === 新增：动态计算卡片的比例 ===
const cardStyle = computed(() => {
  // workbench.promo.ratio 的值通常是 "1:1", "16:9", "3:4" 等格式
  // 而 CSS 的 aspect-ratio 属性接受的格式是 "1 / 1", "16 / 9"
  // 所以我们需要把冒号替换为斜杠
  const currentRatio = workbench.promo.ratio || "1:1";
  return {
    aspectRatio: currentRatio.replace(":", " / "),
  };
});

const onImgError = () => {
  item.value.url = ''
}

const regenerate = () => {
  const current = item.value;
  workbench.generateOne(
    props.index,
    current.customPrompt,
    workbench.getPromoRef()
  );
};
</script>
